import {
  Box,
  Card,
  CardActionArea,
  Chip,
  Radio,
  Typography
} from '@mui/material';

import { CancelDeleteUserButton } from 'src/components/Button';

import { RETENTION_OPTIONS } from './constants';
import { RetentionStepProps } from './types';

const RetentionStep = ({
  selectedOption,
  onOptionChange,
  onContinue
}: RetentionStepProps) => (
  <Box>
    <Box mb={3}>
      <Typography variant="h3" mb={1}>
        Before you cancel, consider these options
      </Typography>
      <Typography color="text.secondary" variant="body1">
        You can pause your subscription or get help from our team before
        canceling.
      </Typography>
    </Box>

    <Box display="flex" flexDirection="column" gap={2}>
      {RETENTION_OPTIONS.map((option) => {
        const isSelected = selectedOption === option.value;
        const Icon = option.icon;

        return (
          <Card
            key={option.value}
            sx={{
              border: 1,
              borderColor: isSelected ? 'primary.main' : 'divider',
              borderRadius: 2,
              boxShadow: isSelected ? '0 0 0 1px' : 'none'
            }}
          >
            <CardActionArea
              onClick={() => onOptionChange(option.value)}
              sx={{
                alignItems: 'stretch',
                p: 2
              }}
            >
              <Box
                alignItems="flex-start"
                display="flex"
                gap={2}
                justifyContent="space-between"
              >
                <Box alignItems="flex-start" display="flex" gap={1.5}>
                  <Box
                    alignItems="center"
                    bgcolor="primary.lighter"
                    borderRadius="50%"
                    display="flex"
                    height={44}
                    justifyContent="center"
                    width={44}
                  >
                    <Icon color={option.iconColor} />
                  </Box>

                  <Box>
                    <Box
                      alignItems="center"
                      display="flex"
                      flexWrap="wrap"
                      gap={1}
                      mb={0.5}
                    >
                      <Typography variant="h5">{option.title}</Typography>
                      {option.recommended ? (
                        <Chip
                          color="success"
                          label="Recommended"
                          size="small"
                        />
                      ) : null}
                    </Box>
                    <Typography color="text.secondary" variant="body2">
                      {option.description}
                    </Typography>
                  </Box>
                </Box>

                <Radio checked={isSelected} value={option.value} />
              </Box>
            </CardActionArea>
          </Card>
        );
      })}
    </Box>

    <Box mt={3}>
      <CancelDeleteUserButton
        fullWidth
        onClick={onContinue}
        variant="contained"
      >
        Continue
      </CancelDeleteUserButton>
    </Box>
  </Box>
);

export default RetentionStep;
